export const LanguageMap = {
    en: { label: "English" },
    "zh-CN": { label: "中文（简体）" },
    "zh-TW": { label: "中文（繁體）" },
};
